// extracted by mini-css-extract-plugin
module.exports = {"root":"Logo__root--1_6fm"};